import {useEffect, useState} from 'react'
import {ISelectOption} from '../utils/core/_model'
import axios from 'axios'
import {BASE_URL} from '../modules/config'

const GET_ALL_CATEGORY_URL = `${BASE_URL}/api/protect/getAllCategory`

const useCategoriesOptions = () => {
  const [categoriesOptions, setCategoriesOptions] = useState<ISelectOption[]>([])

  useEffect(() => {
    const getCategores = async () => {
      try {
        const response = await axios.get<
          {
            id: number
            category_name: string
            user_id: number
            created_at: string
          }[]
        >(GET_ALL_CATEGORY_URL)
        const data = await response.data
        const formatted = data.map((category) => ({
          id: category.id,
          label: category.category_name,
          value: category.category_name,
        }))
        setCategoriesOptions(formatted || [])
      } catch (error) {
        console.log(error)
      }
    }

    getCategores()
  }, [])

  return {categoriesOptions}
}

export default useCategoriesOptions
